import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';

interface ICitizenResponse {
  message: string;
  payload: IPayload;
}

interface ICitizenStatsResponse{
  message: string;
  payload: ICitizenStats

}

export interface ICitizenStats{
  totalCitizens:number;
  citizensWithOngoingCases: number
  averageCasesPerCitizen: number
  percentageFemales: number
  percentageMales: number
  percentageForeigners: number
}
interface IPayload {
  content: ICitizenContent[];
  page: IPage;
}

export interface ICitizenContent {
  id: string;
  fullName: string;
  email: string;
  phoneNumber: string;
  nationalIdNumber: string;
  caseCount: string;
}


interface ICitizenOneResponse {
  message: string;
  payload: ICitizenOneContent;
}

export interface ICitizenOneContent {
  id: string;
  fullName: string;
  email: string;
  gender: string;
  phoneNumber: string;
  nationalIdNumber: string;
  casesCount: number;
  casesOngoingCount: number;
  casesClosedCount: number;
}


export interface ICitizen {
  id?:string;
  fullName: string;
  email: string;
  phoneNumber: string;
  nationalIdNumber: string;
  gender: string;
}

interface IPage {
  size: number;
  number: number;
  totalElements: number;
  totalPages: number;
}

export interface ICreateCitizenResponse {
  message: string;
  payload: any;
}

export interface IUpdateCitizen {
  citizenId: string;
  phoneNumber: string;
}

@Injectable({
  providedIn: 'root',
})
export class CitizensService {
  constructor(private api: ApiService) {}

  getAllCitizens(
    page: number,
    size: number,
    search: string
  ): Observable<ICitizenResponse> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('q', search);

    return this.api.GET<ICitizenResponse>('citizens', { params });
  }

  getCitizenById(citizenId: string): Observable<ICitizenOneContent> {
    return this.api.GET<ICitizenOneResponse>(`citizens/${citizenId}`).pipe(
      map((response) => {
        return response.payload;
      })
    );
  }

  getCitizensStats(){
    return this.api.GET<ICitizenStatsResponse>('citizens/stats');
  }

  createCitizen(citizenData: ICitizen): Observable<ICreateCitizenResponse> {
    return this.api.POST<ICreateCitizenResponse>('citizens', citizenData);
  }

  updateCitizen(citizenUpdateData:IUpdateCitizen): Observable<ICreateCitizenResponse> {
    return this.api.PATCH<ICreateCitizenResponse>(
      `citizens/${citizenUpdateData.citizenId}`,
      {phoneNumber: citizenUpdateData.phoneNumber }
    );
  }

}
